import lodash from 'lodash';

import { UserRoleLabel } from '$shared/constants/Role';
import type { IUser } from '$shared/interfaces/api/IUser';
import { CommonList } from './CommonList';

export default class User {
  public readonly id: string;
  public readonly email: string;
  public readonly firstName: string;
  public readonly lastName: string;
  public readonly role: string;

  constructor(user: IUser) {
    this.id = user.id;
    this.role = user.role;
    this.email = user.email;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
  }

  public get fullName(): string {
    return (
      [this.firstName, this.lastName].filter(Boolean).join(' ') || this.parsedNamefromEmail || ''
    );
  }

  get roleLabel(): string {
    return UserRoleLabel[this.role];
  }

  private get parsedNamefromEmail(): string {
    const name = this.email?.split('@')?.first() || '';
    return name?.replace('.', ' ')?.capitaliseFirstString();
  }

  public toCommonList(): CommonList {
    return CommonList.create(this.fullName, this.id);
  }

  public static getAsCommonList(users: User[]): CommonList[] {
    return lodash.orderBy(
      users.map((user) => user.toCommonList()),
      'label'
    );
  }
}
